import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";
import useLoginMutation from "@/api/mutation/useLoginMutation";
import ErrorMessage from "@/components/common/ErrorMessage";
import { authLoginSchema } from "@backend/src/schemas/authSchema";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { isAxiosError } from "axios";
import InputEmail from "@/components/common/InputEmail";
import { toast } from "react-toastify";
import Google from "../../../assets/svg/google.svg";
// import Facebook from "../../../assets/svg/facebook.svg";
import { baseURL } from "../../../Environment";
import NewLogoTitle from "@/assets/png/NewLogo.png";
import BackgroundImage from "@/components/layout/BackgroundImage";
import InputPassword from "@/components/common/inputPassword";
import useCurruntLocationQuary from "@/api/query/useCurruntLocationQuary";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { errorConfig } from "@/lib/toastError";
import RecaptchaNotice from "../reCaptchaNoticeNotice";

export type LoginValues = {
  email: string;
  password: string;
};

function NewLogin() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const loginMutation = useLoginMutation();
  const navigate = useNavigate();
  const labelStyle = "font-medium text-[13px] text-gray-450 ";
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  const formik = useFormik<LoginValues>({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: toFormikValidationSchema(authLoginSchema),
    onSubmit: (values, helper) => {
      setIsLoading(true);
      loginMutation.mutate(values, {
        onSuccess(data) {
          login();
          if (data.data.data.user.isVerified) {
            navigate("/organisation");
          }
          toast.success(data.data.message);
        },
        onError(error) {
          if (isAxiosError(error)) {
            setIsLoading(false);
            if (
              error.response?.status === 400 &&
              error.response.data?.errors &&
              Array.isArray(error.response?.data.errors)
            ) {
              error.response.data.errors.forEach((item) => {
                helper.setFieldError(item.path[0], item.message);
              });
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(
                errorKeyFormate(error.response?.data.message + ""),
                errorConfig
              );
            }
          }
        },
      });
    },
  });

  const google = () => {
    window.open(`${baseURL}/api/auth/google`, "_self");
  };
  const locationQuary = useCurruntLocationQuary();
  useEffect(() => {
    if (window.history.state?.status && window.history.state.status === 401) {
      if (!toast.isActive("toast401")) {
        toast.error(t("Session expired, please login again"), {
          ...errorConfig,
          toastId: "toast401",
        });
      }
    }
   
  }, [locationQuary.data?.data.data]);

  // useEffect(() => {
  //   i18n.changeLanguage(
  // "fr"
  // locationQuary.data?.data.data?.country === "CA" || locationQuary.data?.data.data?.country === "FR" ? "fr" : "en"
  //   );
  // }, [locationQuary.data?.data.data]);
  // useEffect(() => {
  //   if (!toast.isActive("toast1324") && window.outerWidth < 768 && location.pathname.includes("login")) {
  //     toast.error(
  //       t(
  //         "ProjectChef is not yet optimized for mobile devices. We recommend using a computer for a better user experience"
  //       ),
  //       {
  //         autoClose: false,
  //         closeOnClick: false,
  //         toastId: "toast1324",
  //       }
  //     );
  //   }
  // }, []);
  return (
    <div className="flex justify-center flex-row-reverse min-h-screen bg-secondary-950 sm:px-20 items-center -z-0  h-full w-full">
      <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-full  max-w-xl flex justify-center items-center">
        <img src={NewLogoTitle} className="h-24" />
      </div>
      <BackgroundImage />
      <div className="flex flex-col items-center w-full h-full lg:w-1/2 justify-center overflow-hidden ">
        <div className=" py-8 px-12 w-auto md:w-full max-w-xl overflow-y-auto  bg-white shadow-lg rounded-3xl -z-0">
          <div className="flex gap-2 items-center justify-center w-full h-11 border-2 rounded-lg bg-[#111111]/25 text-white">
            <div
              className={`w-1/2 h-11 rounded-md text-center cursor-pointer flex items-center justify-center ${
                location.pathname == "/login" ? "bg-[#0D062D]" : ""
              }`}
              onClick={handleLoginClick}
            >
              {t("Login")}
            </div>
            <div
              className={`w-1/2 h-11 rounded-md text-center cursor-pointer flex items-center justify-center ${
                location.pathname == "/signup" ? "bg-[#0D062D]" : ""
              }`}
              onClick={handleSignupClick}
            >
              {t("Sign up")}
            </div>
          </div>
          <div className="px-4 py-4 mt-2">
            <h3 className="text-2xl text-center  text-secondary-950">
              {t("Login here")}
            </h3>
          </div>
          <div className="flex flex-col px-4 gap-4 mt-2 items-center">
            <Button
              type="button"
              variant={"outline"}
              isLoading={isLoading}
              disabled={isLoading}
              onClick={google}
              className="md:w-3/4 w-auto flex h-12 py-3 mt-1.5 rounded-3xl border border-[#0D062D] gap-2.5 hover:bg-opacity-80 disabled:bg-opacity-50"
            >
              <img src={Google} />
              <span>{t("Continue with Google")}</span>
            </Button>
            {/* <Button
              type="button"
              variant={"secondary"}
              isLoading={isLoading}
              disabled={isLoading}
              className="w-full flex py-2.5 mt-1.5 rounded-md gap-2.5 hover:bg-[#1876f2d8] bg-[#1877F2] text-white"
            >
              <img src={Facebook} />
              <span>
                Facebook
              </span>
            </Button> */}
          </div>
          <div className="flex items-center py-4 mt-2">
            <hr className="flex-grow border-[#666666]/25" />
            <div className="px-4 text-gray-400 text-xs">OR</div>
            <hr className="flex-grow border-[#666666]/25" />
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className=" py-2 flex flex-col gap-3 h-[75%] "
          >
            <div className="w-full mt-1">
              <label htmlFor="email" className={labelStyle}>
                {t("Email")}
                {/* <span className="ml-0.5 text-red-500">*</span> */}
              </label>
              <InputEmail
                name="email"
                id="loginEmail"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <div>
                <ErrorMessage className="!text-xs block mt-1">
                  {formik.touched.email && t(formik.errors.email ?? "")}
                </ErrorMessage>
              </div>
            </div>
            <div className="w-full mt-1">
              <label htmlFor="password" className={labelStyle}>
                {t("Password")}
                {/* <span className="ml-0.5 text-red-500">*</span> */}
              </label>
              <div className="relative mt-1">
                <InputPassword
                  name="password"
                  id="loginPassword"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              <div>
                <ErrorMessage className="!text-xs block mt-1">
                  {formik.touched.password && t(formik.errors.password ?? "")}
                </ErrorMessage>
              </div>
              <NavLink
                className="mt-4 text-xs text-right text-[#666666] underline flex justify-end w-fit ml-auto"
                to="/forgot-password"
              >
                {t("Forget Password?")}
              </NavLink>
            </div>
            <div className="flex items-center mt-auto">
              <Button
                type="submit"
                id="submit"
                variant={"primary"}
                isLoading={isLoading}
                disabled={isLoading}
                className="w-full text-white  py-2.5 mt-1.5 rounded-md hover:bg-opacity-80 disabled:bg-opacity-50"
              >
                {t("Login")}
              </Button>
            </div>

            <div className="mt-2 text-sm text-grey-600 m-auto">
              {t("Not User?")}{" "}
              <NavLink className="font-bold underline" to="/signup">
                {t("Click here to Sign Up")}
              </NavLink>
            </div>
          </form>
          <RecaptchaNotice/>
        </div>
      </div>
      {/* {isMobailView && (
        <div className="w-full">
          <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-full lg:w-2/5 flex justify-center items-center">
            <img src={NewLogoTitle} className="h-24" />
          </div>
          <div className="font-bold text-base text-white text-center my-2 p-3">
           {t("mobilError")}
          </div>
        </div>
      )} */}
      {/* <div className="lg:flex flex-col items-center justify-center lg:w-1/2 hidden w-full gap-6 ">
        <div className=" bg-primary-500/20 rounded-br-3xl absolute top-0 rounded-bl-3xl mb-5 h-24 w-full lg:w-2/5 flex justify-center items-center">
          <img src={NewLogoTitle} className="h-24" />
        </div>

        <div className="flex gap-3 w-full justify-between">
          <div className="text-center">
            <span className="font-bold text-xl text-white contents">
              {t("Discover more advanced features on")}{" "}
              <span className="text-primary-500">ProjectChef</span>
              {t(
                ", that enable you to achieve your goals efficiently and collaboratively"
              )}
            </span>
          </div>
        </div>
        <div className="flex gap-3 w-full justify-between">
          <div className="mt-1">
            <img src={checkMark} alt="" className="min-w-5 w-5" />
          </div>
          <div className="">
            <div className="font-bold text-xl text-white">
              {t("Dynamic Gantt Chart")}
            </div>
            <div className="text-gray-500">
              {t("Dynamic Gantt Chart Description")}
            </div>
          </div>
        </div>
        <div className="flex gap-3 w-full justify-between">
          <div className="mt-1">
            <img src={checkMark} alt="" className="min-w-5 w-5" />
          </div>
          <div className="">
            <div className="font-bold text-xl text-white">
              {t("Customizable Kanban Board")}
            </div>
            <div className="text-gray-500">
              {t("Customizable Kanban Board Description")}
            </div>
          </div>
        </div>
        <div className="flex gap-3 w-full justify-between">
          <div className="mt-1">
            <img src={checkMark} alt="" className="min-w-5 w-5" />
          </div>
          <div className="">
            <div className="font-bold text-xl text-white">
              {t("Centralized Task Management")}
            </div>
            <div className="text-gray-500">
              {t("Centralized Task Management Description")}
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default NewLogin;
